<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" class="mt-8"/>

    <!-- 작업 정보-->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 작업 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div class="writeGridCol2">
          <div>작업내용</div>
          <p v-if="isPrint" class="print-input">{{ form.작업내용 }}</p>
          <ml-input v-else v-model="form.작업내용" class="w-full" />
        </div>
        <div />

        <div>
          <div>작업일시</div>
          <p v-if="isPrint" class="print-input">{{ form.작업일시 }}</p>
          <date-selector v-else v-model="form.작업일시" class="w-full" />
        </div>
        <div>
          <div>작업시간</div>
          <div class="flex">
            <p v-if="isPrint" class="print-input">{{ form.작업시간.start }}</p>
            <time-selector v-else v-model="form.작업시간.start" class="w-full" />
            <span class="mx-2">~</span>
            <p v-if="isPrint" class="print-input">{{ form.작업시간.end }}</p>
            <time-selector v-else v-model="form.작업시간.end" class="w-full" />
          </div>
        </div>
        <div />

        <div class="writeGridCol2">
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ form.작업장소 }}</p>
          <ml-input v-else v-model="form.작업장소" class="w-full" />
        </div>
        <div />

        <div>
          <div>소요인원(작업책임자)</div>
          <p v-if="isPrint" class="print-input">{{ form.소요인원_작업책임자 }}</p>
          <ml-input v-else v-model="form.소요인원_작업책임자" class="w-full" type="number" />
          <div class="ml-1">인</div>
        </div>
        <div>
          <div>비고</div>
          <p v-if="isPrint" class="print-input">{{ form.소요인원_작업책임자_비고 }}</p>
          <ml-input v-else v-model="form.소요인원_작업책임자_비고" class="w-full" />
        </div>
        <div />

        <div>
          <div>소요인원(작업자)</div>
          <p v-if="isPrint" class="print-input">{{ form.소요인원_작업자 }}</p>
          <ml-input v-else v-model="form.소요인원_작업자" class="w-full" type="number" />
          <div class="ml-1">인</div>
        </div>
        <div>
          <div>비고</div>
          <p v-if="isPrint" class="print-input">{{ form.소요인원_작업자_비고 }}</p>
          <ml-input v-else v-model="form.소요인원_작업자_비고" class="w-full" />
        </div>
      </div>
    </div>

    <!-- 작업방법-->
    <div>
      <vs-row class="mt-6">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 작업방법</h5>
        </vs-col>
      </vs-row>
      <p class="my-4" style="font-weight: 700; font-size: 15px; color: #2c2c2c">- 업무분담</p>

      <div class="writeGridContainer mt-4">
        <div class="writeGridCol2">
          <div>작업책임자</div>
          <p v-if="isPrint" class="print-input">{{ form.작업책임자 }}</p>
          <ml-input v-else v-model="form.작업책임자" class="w-full" />
        </div>

        <div class="writeGridCol2">
          <div>감시인</div>
          <p v-if="isPrint" class="print-input">{{ form.감시인 }}</p>
          <ml-input v-else v-model="form.감시인" class="w-full" />
        </div>

        <div class="writeGridCol2">
          <div>작업자</div>
          <p v-if="isPrint" class="print-input">{{ form.작업자 }}</p>
          <ml-input v-else v-model="form.작업자" class="w-full" />
        </div>
      </div>

      <p class="my-4" style="font-weight: 700; font-size: 15px; color: #2c2c2c">- 장비</p>
      <div class="writeGridContainer">
        <div class="writeGridCol2">
          <div>작업장비</div>
          <p v-if="isPrint" class="print-input">{{ form.작업장비 }}</p>
          <ml-input v-else v-model="form.작업장비" class="w-full" />
        </div>

        <div class="writeGridCol2">
          <div>안전장비</div>
          <p v-if="isPrint" class="print-input">{{ form.안전장비 }}</p>
          <ml-input v-else v-model="form.안전장비" class="w-full" />
        </div>
      </div>

    </div>

    <p class="my-4" style="font-weight: 700; font-size: 15px; color: #2c2c2c">- 작업진행계획</p>
    <div>
      <p v-if="isPrint" class="print-textarea">{{ form.작업진행계획 }}</p>
      <ml-textarea v-else v-model="form.작업진행계획" class="w-full" />
    </div>

    <!-- 구조계획-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 구조계획</h5>
      </vs-col>
    </vs-row>

    <div class="mt-4 flex gap-2">
      <div style="width: 280px; align-self: center;">1. 비상 구조에 필요한 장비</div>
      <div v-for="item in form.필요장비" class="flex" style="align-items: center;">
        <print-checkbox v-if="isPrint" :value="item.isChecked" />
        <vs-checkbox v-else v-model="item.isChecked" />
        <span class="mr-2">{{ item.label }}</span>
        <div v-if="item.value === '기타'">
          <p v-if="isPrint" class="print-input">{{ item.comment }}</p>
          <ml-input v-else v-model="item.comment" />
        </div>
      </div>
    </div>
    <div class="mt-2 flex gap-2">
      <div style="width: 280px;  align-self: center;">2. 밀폐공간에 사용하는 호흡 장비의 유형</div>
      <div class="flex gap-2" style="align-items: center;">
        <span class="whitespace-no-wrap">- 작업용</span>
        <p v-if="isPrint" class="print-input">{{ form.장비유형_작업용 }}</p>
        <ml-input v-else v-model="form.장비유형_작업용" style="width: 345px;"/>

        <span class="whitespace-no-wrap">- 구조용</span>
        <p v-if="isPrint" class="print-input">{{ form.장비유형_구조용 }}</p>
        <ml-input v-else v-model="form.장비유형_구조용" style="width: 345px;"/>
      </div>
    </div>
    <div class="mt-2 flex gap-2">
      <div style="width: 280px;  align-self: center;">3. 비상상황 연락 방법</div>
      <div v-for="item in form.연락방법" class="flex" style="align-items: center;">
        <print-checkbox v-if="isPrint" :value="item.isChecked" />
        <vs-checkbox v-else v-model="item.isChecked" />
        <span class="mr-2">{{ item.label }}</span>
        <div v-if="item.value !== '무전기'">
          <p v-if="isPrint" class="print-input">{{ item.comment }}</p>
          <ml-input v-else v-model="item.comment" />
        </div>
      </div>
    </div>
    <div class="mt-4 flex gap-2">
      <div style="width: 280px;  align-self: center;">4. 구조방법</div>
      <div v-for="item in form.구조방법" class="flex" style="align-items: center;">
        <print-checkbox v-if="isPrint" :value="item.isChecked" />
        <vs-checkbox v-else v-model="item.isChecked" />
        <span class="mr-2">{{ item.label }}</span>
      </div>
    </div>
    <div class="mt-4 flex gap-2">
      <div style="width: 280px;  align-self: center;">5. 구조팀원 명단 및 임무</div>
      <div class="flex gap-2" style="align-items: center;">
        <span class="whitespace-no-wrap">구조팀원 명단</span>
        <p v-if="isPrint" class="print-input">{{ form.구조팀원_명단 }}</p>
        <ml-input v-else v-model="form.구조팀원_명단" class="w-full" style="min-width: 500px;"/>
      </div>
    </div>

    <table class="mt-4">
      <colgroup>
        <col width="266" />
        <col width="266" />
        <col />
      </colgroup>
      <thead>
      <tr>
        <th>업무</th>
        <th>이름</th>
        <th>임무내용</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <div>감시자</div>
        </td>
        <td>
          <p v-if="isPrint" class="print-input">{{ form.구조팀원_감시자 }}</p>
          <ml-input v-else v-model="form.구조팀원_감시자" class="w-full" />
        </td>
        <td>
          <span>
            1. 출입자를 감시한다.<br/>
2. 출입자와 끊임없이 통신하고 구명로프를 주시한다.<br/>
3. 비상 상황이 나빠지면 도움을 요청한다.<br/>
4. 가능한 사고자를 이송하기 위해 외부에서 구조 수행한다.<br/>
5. 개인보호구 없이 절대로 밀폐공간에 들어가지 않는다.
          </span>
        </td>
      </tr>

      <tr>
        <td>
          <div>2차 감시자</div>
        </td>
        <td>
          <p v-if="isPrint" class="print-input">{{ form.구조팀원_2차감시자 }}</p>
          <ml-input v-else v-model="form.구조팀원_2차감시자" class="w-full" />
        </td>
        <td>
          <span>
            1. 전화를 이용하여 도움을 청한다.<br/>
2. 밀폐공간에 들어가는 감시인을 도와준다.<br/>
3. 사고자를 이송하는 감시인을 도와준다.
          </span>
        </td>
      </tr>

      <tr>
        <td>
          <div>구조자</div>
        </td>
        <td>
          <p v-if="isPrint" class="print-input">{{ form.구조팀원_구조자 }}</p>
          <ml-input v-else v-model="form.구조팀원_구조자" class="w-full" />
        </td>
        <td>
          <span>
            1. 필요한 응급처치 수행(심폐소생술 포함)<br/>
2. 사고에 대한 필요한 정보를 제공하기 위해 병원으로 동행
          </span>
        </td>
      </tr>
      </tbody>
    </table>

    <!-- 비상연락망 -->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 비상연락망</h5>
      </vs-col>
    </vs-row>
    <div class="mt-4">
      <p v-if="isPrint" class="print-textarea">{{ form.비상연락망 }}</p>
      <ml-textarea v-else v-model="form.비상연락망" class="w-full" />
    </div>

    <!-- 확인자 -->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 확인자</h5>
      </vs-col>
    </vs-row>
    <name-with-signature-row label-name="담당" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
    <name-with-signature-row label-name="팀장" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
    <name-with-signature-row label-name="과장" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" title="파일첨부" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    PrintCheckbox,
    TimeSelector,
    DateSelector,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      allCheck: false,
      form: {
        stdInfo: {},
        fileList: [],

        // 작업 정보
        작업내용: "",
        작업일시: "",
        작업시간: {
          start: "",
          end: "",
        },
        작업장소: "",
        소요인원_작업책임자: "",
        소요인원_작업책임자_비고: "",
        소요인원_작업자: "",
        소요인원_작업자_비고: "",

        // 작업방법
        작업책임자: "",
        감시인: "",
        작업자: "",
        작업장비: "",
        안전장비: "",
        작업진행계획: "",

        // 구조계획
        필요장비: [
          { isChecked: false, label: "그네식 안전대", value: "그네식안전대", },
          { isChecked: false, label: "구명로프", value: "구명로프", },
          { isChecked: false, label: "응급구조 삼각대", value: "응급구조삼각대", },
          { isChecked: false, label: "송기마스크", value: "송기마스크", },
          { isChecked: false, label: "소화기", value: "소화기", },
          { isChecked: false, label: "기타", value: "기타", },
        ],
        장비유형_작업용: "",
        장비유형_구조용: "",
        연락방법: [
          { isChecked: false, label: "전화", value: "전화", },
          { isChecked: false, label: "무전기", value: "무전기", },
          { isChecked: false, label: "기타", value: "기타", },
        ],
        구조방법: [
          { isChecked: false, label: "외부구조법", value: "외부구조법", },
          { isChecked: false, label: "내부구조법", value: "내부구조법", },
        ],
        구조팀원_명단: "",
        구조팀원_감시자: "",
        구조팀원_2차감시자: "",
        구조팀원_구조자: "",

        비상연락망: "",

        sign1: { name: "", sign: "" },
        sign2: { name: "", sign: "" },
        sign3: { name: "", sign: "" },
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    addRow() {
      this.form.보호구지급대장.push({ id: Math.random().toString(36).substr(2, 9)});
      this.allCheck = false;
    },
    deleteRow() {
      const selectedRow = this.form.보호구지급대장.filter((row) => row.selected);
      if (selectedRow.length === 0) {
        return;
      }

      this.form.보호구지급대장 = this.form.보호구지급대장.filter((row) => !row.selected);
      this.allCheck = false;
    },
    onClickAllCheckBox() {
      setTimeout(() => {
        if (this.allCheck) {
          this.form.보호구지급대장.forEach((row) => row.selected = true);
        } else {
          this.form.보호구지급대장.forEach((row) => row.selected = false);
        }
      }, 100);
    },
  },
  computed: {
    checkedSelectedItem() {
      return this.form.보호구지급대장.filter((row) => row.selected).length === 0;
    },
  }
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 400;
        color: #3c3c3c;
        line-height: 17px;
        padding: 14px;
        border: solid #cdcdcd 1px;

        div {
          justify-self: center;
          align-items: center;
          font-size: 15px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
